import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import articlesData from './articlesData';

const ArticlesList = () => {
  const siteUrl = 'https://yoursite.com';

  return (
    <>
      <Helmet>
        <html lang="en" />
        <title>Статьи | ICMO Summit Awards</title>
        <meta
          name="description"
          content="Новости, основные моменты и комментарии экспертов от ICMO Summit Awards."
        />
        <meta
          name="keywords"
          content="ICMO Summit Awards articles, marketing awards news, jury insights, winners"
        />
        <link rel="canonical" href={`${siteUrl}/articles`} />

        <meta property="og:type" content="website" />
        <meta property="og:title" content="Articles | ICMO Summit Awards" />
        <meta
          property="og:description"
          content="Новости, основные моменты и комментарии экспертов от ICMO Summit Awards."
        />
        <meta property="og:url" content={`${siteUrl}/articles`} />
        <meta property="og:site_name" content="ICMO Summit Awards" />
      </Helmet>

      <section className="articles-page">
        <div className="articles-page__inner">
          <h1 className="articles-page__title">Статьи</h1>
          <p className="articles-page__intro">
            Новости, основные моменты и комментарии экспертов от ICMO Summit Awards.
          </p>

          <div className="articles-grid">
            {articlesData.map((article) => (
              <article key={article.id} className="article-card">
                <Link
                  to={`/articles/${article.id}`}
                  className="article-card__image-link"
                >
                  <img
                    src={article.image}
                    alt={article.imageAlt || article.title}
                    className="article-card__image"
                  />
                </Link>

                <div className="article-card__content">
                  <div className="article-card__date">{article.date}</div>

                  <h2 className="article-card__title">
                    <Link to={`/articles/${article.id}`}>{article.title}</Link>
                  </h2>

                  <p className="article-card__excerpt">
                    {article.seoDescription || article.text}
                  </p>

                  <Link to={`/articles/${article.id}`} className="article-card__link">
                    Read more
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default ArticlesList;